<template>
    <div class="rightPage">
        <v-search
            :formContent="formContent"
            :SearchForm="SearchForm"
            :inline="true"
            :optareBtn="optareBtn"
            @resetFn="resetFn"
            @searchFn="getListFn"
            @appoveFn="appoveFn"
            @delFn="delFn"
            @exportFn="exportFn"
        />
        <!-- 默认参数就是监测点的配置 -->
        <div class="question">
            <span v-for="(i, key) in approvalStatus" :key="key" class="icon-margin">
                <i :class="i.icon" class="icon-margin"></i><span>{{ $t(i.title) }}</span>
            </span>
        </div>
        <div class="componentPage">
            <v-table
                :tableData="tableData"
                :loading="loading"
                @choozeTable="choozeTable"
                @detailFn="detailFn"
                @delRowFn="delRowFn"
                @approveFn="approveFn($event, 1)"
                @noApproveFn="approveFn($event, 0)"
            />
            <Pagination class="pagination" :total="total" :page.sync="SearchForm.iDisplayStart" :limit.sync="SearchForm.iDisplayLength" @pagination="getListFn"></Pagination>
        </div>
        <!-- 审批 -->
        <Approve :isShow.sync="isShow" :title="title" :choozeTableData="choozeTableData" />
        <!-- 数据记录弹窗 -->
        <DataPoint :title="title" :isPointShow.sync="isPointShow" :pointId="pointId" />
    </div>
</template>

<script>
import formMixin from '@/utils/formMixins.js';
import bus from '@/utils/bus.js';
import IconDesc from '@/components/IconDesc/IconDesc.vue';
import table from './Table.vue';
import Approve from '../components/Approve.vue';
import DataPoint from '../components/dataPoint.vue';

import { carrierRecordList, carrieDel, carrieExport, carrierRecordUpdate, carrierRecordDetail } from '@/api/modules/record.js';
import { approvalStatus } from '@/utils/convert';
import { getLanguage } from '@/lang';

export default {
    components: {
        'v-table': table,
        Approve,
        DataPoint,
        IconDesc
    },
    mixins: [formMixin],
    data() {
        return {
            approvalStatus,
            formContent: [
                {
                    id: 1,
                    text: $t('integration.recordDate'),
                    type: 'date',
                    paramsName: 'startDateArray',
                    isChooze: true
                },
                {
                    id: 2,
                    text: $t('integration.approval_time'),
                    type: 'datetimerange',
                    paramsName: 'time',
                    isChooze: false
                },
                {
                    id: 3,
                    text: 'public.status',
                    type: 'select',
                    paramsName: 'status',
                    isChooze: false,
                    selectParam: [
                        {
                            value: '',
                            label: 'public.please'
                        }
                    ]
                },
                {
                    id: 4,
                    text: $t('integration.approval'),
                    type: 'select',
                    paramsName: 'approve',
                    isChooze: false,
                    selectParam: [
                        {
                            value: '',
                            label: 'public.please'
                        }
                    ]
                },
                {
                    id: 5,
                    text: 'public.carrier',
                    type: 'input',
                    paramsName: 'carrierName',
                    isChooze: false
                },
                {
                    id: 6,
                    text: $t('integration.approver'),
                    type: 'input',
                    paramsName: 'approveName',
                    isChooze: false
                }
            ],
            SearchForm: {
                startDateArray: [],
                time: null,
                status: null,
                approve: null,
                carrierName: null,
                approveName: null
            },
            optareBtn: [
                {
                    id: 1,
                    icon: '',
                    vHas: ['delRange'],
                    text: $t('integration.approval'),
                    method: 'appoveFn'
                },
                {
                    id: 2,
                    icon: '',
                    vHas: ['delRange'],
                    text: 'public.tbopt_delete',
                    method: 'delFn'
                },
                {
                    id: 3,
                    icon: '',
                    vHas: ['delRange'],
                    text: $t('integration.export'),
                    method: 'exportFn'
                }
            ],
            rightArray: [
                {
                    id: 1,
                    color: 'green',
                    icon: 'el-icon-circle-check',
                    text: $t('integration.approved')
                },
                {
                    id: 2,
                    color: 'red',
                    icon: 'el-icon-circle-close',
                    text: $t('integration.approval_rejected')
                },
                {
                    id: 3,
                    color: 'grey',
                    icon: 'el-icon-circle-close',
                    text: $t('integration.not_approved')
                }
            ],
            dateArray: [],
            // 审批
            isShow: false,
            title: '',
            choozeTableData: [],
            // 数据记录点弹窗
            isPointShow: false,
            // 数据点分页
            pointId: ''
        };
    },
    created() {
        this.defaultDate();
        this.ApprovalFn();
    },
    mounted() {
        bus.$on('nodeClickFn', row => {
            if (row.id === 'all') {
                this.SearchForm.sceneId = null;
                this.SearchForm.scopeId = null;
            }
            // 一级范围
            else if (row.level === 0 && row.id !== 'all') {
                (this.SearchForm.sceneId = null), (this.SearchForm.scopeId = row.scopeId);
            } else {
                this.SearchForm.scopeId = row.scopeId;
                this.SearchForm.sceneId = row.sceneId;
            }
            this.getListFn();
        });
    },
    methods: {
        /** 获取审批状态 */
        ApprovalFn() {
            let P1 = carrierRecordDetail({ code: 'acquisition_status', type: 0 });
            let P2 = carrierRecordDetail({ code: 'approval_status', type: 0 });
            // let P3 = carrierRecordDetail({code:'approval_status',type:0});
            Promise.all([P1, P2]).then(res => {
                this.formContent[3].selectParam = this.formContent[3].selectParam.concat(
                    res[1].result.map(item => {
                        return {
                            label: getLanguage() === 'zh_CN'?item.name: item.content,
                            value: item.code
                        };
                    })
                );
                this.formContent[2].selectParam = this.formContent[2].selectParam.concat(
                    res[0].result.map(item => {
                        return {
                            label: getLanguage() === 'zh_CN'?item.name: item.content,
                            value: item.code
                        };
                    })
                );
            });
        },
        resetFn() {
            (this.SearchForm = {
                startDateArray: [],
                time: null,
                status: null,
                approve: null,
                carrierName: null,
                approveName: null,
                iDisplayStart: 0,
                iDisplayLength: 15
            }),
                (this.SearchForm.startDateArray = [...this.dateArray]);
            this.getListFn();
        },
        defaultDate() {
            let curYear,
                curMonth = '';
            let nextYear = '',
                nextMonth = '';
            curYear = new Date().getFullYear();
            (curMonth = new Date().getMonth() + 1), (nextMonth = curMonth + 1);
            if (curMonth >= 13) {
                nextMonth = 1;
                nextYear = curYear + 1;
            } else {
                nextYear = curYear;
            }
            let startDate = curYear + '-' + curMonth + '-' + '01';
            let endDate = nextYear + '-' + nextMonth + '-' + '01';
            this.dateArray = [startDate, endDate];
            this.SearchForm.startDateArray = [startDate, endDate];
        },
        getListFn() {
            this.loading = true;
            if (this.SearchForm.time && this.SearchForm.time.length > 0) {
                this.SearchForm.approveStartTime = this.$dateParseTime(this.SearchForm.time[0]);
                this.SearchForm.approveEndTime = this.$dateParseTime(this.SearchForm.time[1]);
            } else {
                this.SearchForm.approveStartTime = null;
                this.SearchForm.approveEndTime = null;
            }
            let param = {};
            if (this.SearchForm.startDateArray && this.SearchForm.startDateArray.length === 0) {
                param.startDate = this.dateArray[0];
                param.endDate = this.dateArray[1];
            } else {
                param.startDate = this.SearchForm.startDateArray ? this.SearchForm.startDateArray[0] : null;
                param.endDate = this.SearchForm.startDateArray ? this.SearchForm.startDateArray[1] : null;
            }

            for (let key in this.SearchForm) {
                param[key] = this.SearchForm[key];
            }
            delete param['time'], delete param['startDateArray'];
            carrierRecordList(param)
                .then(({ result, pageInfo }) => {
                    this.total = pageInfo.total;
                    this.tableData = result;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        choozeTable(row) {
            this.choozeTableData = row;
        },
        /** 区分勾选中的数据是否是已经审批 */
        distinguishTypeFn(str) {
            if (this.choozeTableData.length === 1) {
                return this.choozeTableData[0].approve === 1 ? false : true;
            }

            let oneParam = this.choozeTableData[0];
            let flag = true;
            for (let item of this.choozeTableData) {
                if (oneParam[str] !== item[str]) {
                    flag = false;
                    break;
                } else {
                    flag = true;
                }
            }
            return flag;
        },
        /** 多条审批 */
        appoveFn() {
            if (this.choozeTableData.length === 0) return this.$message.warning(this.$t('public.least_one_data'));
            let flag = this.distinguishTypeFn('approve');
            if (!flag) return this.$message.error($t('integration.the_selected_data_has_approved_data'));
            let flag2 = this.distinguishTypeFn('carrierName');
            if (!flag2) return this.$message.error($t('integration.please_select_the_same_mounting_data_for_approval'));
            let flag3 = this.distinguishTypeFn('recordDate');
            if (!flag3) return this.$message.error($t('integration.please_select_the_same_time_record_point_data'));
            this.title = $t('integration.approval');
            console.log(this.choozeTableData);
            this.isShow = true;
        },
        /** 单条审批通过 */
        approveFn(row, num) {
            this.$confirm()
                .then(() => {
                    carrierRecordUpdate({
                        id: row.id,
                        approve: num
                    }).then(({ state }) => {
                        if (state.code === 200) {
                            this.$message.success(this.$t('public.tip_oper_succ'));
                            this.getListFn();
                        } else {
                            this.$message.error(state.msg);
                        }
                    });
                })
                .catch(() => {});
        },
        /** 多条删除 */
        delFn() {
            if (this.choozeTableData.length === 0) return this.$message.warning(this.$t('public.least_one_data'));
            let ids = this.choozeTableData.map(item => item.id).join(',');
            this.$confirm(this.$t('messageTitle.DeleteToContinue'), this.$t('public.prompt'), {
                confirmButtonText: this.$t('public.btn_yes'), // 确定按钮的文案
                cancelButtonText: this.$t('public.btn_cancel'), // 取消按钮的文案
                type: 'warning'
            })
                .then(() => {
                    carrieDel({ ids }).then(({ result, state }) => {
                        if (state.code === 200) {
                            if (result === 0) {
                                this.$message.error(this.$t('public.tip_del_fail'));
                            } else if (result === 1) {
                                this.$message.success($t('integration.successfully_deleted'));
                                this.getListFn();
                            } else {
                                this.$message.success($t('integration.system_error'));
                            }
                        } else {
                            this.$message.error(state.msg);
                        }
                    });
                })
                .catch(() => {});
        },
        /** 单条删除 */
        delRowFn(row) {
            this.$confirm(this.$t('messageTitle.DeleteToContinue'), this.$t('public.prompt'), {
                confirmButtonText: this.$t('public.btn_yes'), // 确定按钮的文案
                cancelButtonText: this.$t('public.btn_cancel'), // 取消按钮的文案
                type: 'warning'
            })
                .then(() => {
                    carrieDel({ ids: row.id }).then(({ result, state }) => {
                        if (state.code === 200) {
                            if (result === 0) {
                                this.$message.error(this.$t('public.tip_del_fail'));
                            } else if (result === 1) {
                                this.$message.success($t('integration.successfully_deleted'));
                                this.getListFn();
                            } else {
                                this.$message.success($t('integration.system_error'));
                            }
                        } else {
                            this.$message.error(state.msg);
                        }
                    });
                })
                .catch(() => {});
        },
        /** 导出 */
        async exportFn() {
            if (this.choozeTableData.length === 0) return this.$message.warning(this.$t('public.least_one_data'));
            let pointIds = this.choozeTableData.map(item => item.id);
            const params = {
                pointIds,
                isCoverage: 0,
                from: new Date(this.SearchForm.startDateArray[0]).getTime(),
                to: new Date(this.SearchForm.startDateArray[1]).getTime()
            };
            let result = (await carrieExport(params)).result;
            if (result.status === 300) {
                await this.$confirm($t('integration.the_file_already_exists._do_you_want_to_overwrite_it'));
                params.isCoverage = 1;
                result = (await carrieExport(params)).result;
            }
            if (result.status === 200) this.$store.state.downLoad.listids.push(result.recordId);
        },
        /** 数据详细 */
        detailFn(row) {
            this.title = `[${row.carrierName}][${row.recordDate}]-` + $t($t('integration.data_record'));
            this.isPointShow = true;
            this.pointId = row.id;
        }
    }
};
</script>

<style lang="scss" scoped>
.rightPage {
    position: rea;
    height: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    box-sizing: border-box;

    .componentPage {
        flex: 1;

        .pagination {
            padding-top: 0;
            padding-right: 15px !important;
            display: flex;
            align-items: center;
            justify-content: flex-end;
        }
    }
    .question {
        position: absolute;
        right: 20px;
        top: 65px;
        font-size: 18px;

        color: #9bccfd;
    }
}
</style>
